import type {SignInput} from '../../lib/sign-catalog'

export interface WizardState {
    readonly stepIndex: number
    readonly stepCount: number
    readonly input: SignInput
}

export type WizardAction =
    | {type: 'next'}
    | {type: 'prev'}
    | {type: 'patch'; patch: Partial<SignInput>}
    | {type: 'reset'; input: SignInput; stepCount: number}

export function wizardReducer(state: WizardState, action: WizardAction): WizardState {
    switch (action.type) {
        case 'next':
            return {...state, stepIndex: Math.min(state.stepIndex + 1, state.stepCount - 1)}
        case 'prev':
            return {...state, stepIndex: Math.max(state.stepIndex - 1, 0)}
        case 'patch':
            return {...state, input: {...state.input, ...action.patch}}
        case 'reset':
            return {stepIndex: 0, stepCount: action.stepCount, input: action.input}
    }
}
